import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'environment',
      type: 'input',
      label: '名称',
      placeholder: '请输入名称'
    },
    {
      field: 'belongType',
      type: 'select',
      label: '使用项目',
      clearable: true,
      placeholder: '项目',
      options: [
        {title: '全部', value: ''},
        {title: '运营辅助平台', value: 1},
        {title: '微控平台', value: 2},
        {title: '直播间', value: 3},
        {title: '企业微信检查系统', value: 4},
        {title: '与牛共舞', value: 5}
      ]
    }
  ]
}
